module.exports = __webpack_public_path__ + "img/emotion-hands-self.4c5add41.svg";